module.exports = __webpack_public_path__ + "bundle/assets/red-man-100@2x.78b43554.png";


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/YouAreHereLayer/red-man-100@2x.png
// module id = 69
// module chunks = 0